/* src/components/RedoUndo/RedoUndo.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	subscribe,
	transition_in,
	transition_out
} from "svelte/internal";

import Icon from "../Icon";
import Icons from "../Icons";
import Button from "../Button";

function create_default_slot_3(ctx) {
	let icons_undo;
	let current;
	icons_undo = new Icons.Undo({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_undo.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_undo, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_undo_changes = {};
			if (dirty & /*theme*/ 1) icons_undo_changes.theme = /*theme*/ ctx[0];
			icons_undo.$set(icons_undo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_undo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_undo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_undo, detaching);
		}
	};
}

// (47:2) <Button class="undo" {name} {theme} disabled={undo_disabled} on:click={undo} content={t.undo}>
function create_default_slot_2(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.undo[/*type*/ ctx[2]],
				alt: "[undo]",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 6) icon_changes.src = /*icons*/ ctx[1]?.undo[/*type*/ ctx[2]];

			if (dirty & /*$$scope, theme*/ 131073) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (53:4) <Icon src={icons?.redo[type]} alt="[redo]">
function create_default_slot_1(ctx) {
	let icons_redo;
	let current;
	icons_redo = new Icons.Redo({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_redo.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_redo, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_redo_changes = {};
			if (dirty & /*theme*/ 1) icons_redo_changes.theme = /*theme*/ ctx[0];
			icons_redo.$set(icons_redo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_redo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_redo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_redo, detaching);
		}
	};
}

// (52:2) <Button class="redo" {name} {theme} disabled={redo_disabled} on:click={redo} content={t.redo}>
function create_default_slot(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.redo[/*type*/ ctx[2]],
				alt: "[redo]",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 6) icon_changes.src = /*icons*/ ctx[1]?.redo[/*type*/ ctx[2]];

			if (dirty & /*$$scope, theme*/ 131073) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let button0;
	let t_1;
	let button1;
	let div_class_value;
	let current;

	button0 = new Button({
			props: {
				class: "undo",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*undo_disabled*/ ctx[4],
				content: /*t*/ ctx[7].undo,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*undo*/ ctx[9]);

	button1 = new Button({
			props: {
				class: "redo",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*redo_disabled*/ ctx[3],
				content: /*t*/ ctx[7].redo,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*redo*/ ctx[10]);

	return {
		c() {
			div = element("div");
			create_component(button0.$$.fragment);
			t_1 = space();
			create_component(button1.$$.fragment);
			attr(div, "class", div_class_value = "" + (name + " " + /*theme*/ ctx[0]));
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(button0, div, null);
			append(div, t_1);
			mount_component(button1, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const button0_changes = {};
			if (dirty & /*theme*/ 1) button0_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*undo_disabled*/ 16) button0_changes.disabled = /*undo_disabled*/ ctx[4];
			if (dirty & /*t*/ 128) button0_changes.content = /*t*/ ctx[7].undo;

			if (dirty & /*$$scope, icons, type, theme*/ 131079) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);
			const button1_changes = {};
			if (dirty & /*theme*/ 1) button1_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*redo_disabled*/ 8) button1_changes.disabled = /*redo_disabled*/ ctx[3];
			if (dirty & /*t*/ 128) button1_changes.content = /*t*/ ctx[7].redo;

			if (dirty & /*$$scope, icons, type, theme*/ 131079) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);

			if (!current || dirty & /*theme*/ 1 && div_class_value !== (div_class_value = "" + (name + " " + /*theme*/ ctx[0]))) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(button0);
			destroy_component(button1);
		}
	};
}

const i18n = {
	en: { redo: "Redo", undo: "Undo" },
	"zh-CN": {
		redo: "\u91CD\u505A",
		undo: "\u64A4\u9500"
	}
};

const name = "fastboard-redo-undo";

function instance($$self, $$props, $$invalidate) {
	let writable;
	let disabled;
	let t;
	let undoSteps;
	let redoSteps;
	let undo_disabled;
	let redo_disabled;

	let $redoSteps,
		$$unsubscribe_redoSteps = noop,
		$$subscribe_redoSteps = () => ($$unsubscribe_redoSteps(), $$unsubscribe_redoSteps = subscribe(redoSteps, $$value => $$invalidate(14, $redoSteps = $$value)), redoSteps);

	let $undoSteps,
		$$unsubscribe_undoSteps = noop,
		$$subscribe_undoSteps = () => ($$unsubscribe_undoSteps(), $$unsubscribe_undoSteps = subscribe(undoSteps, $$value => $$invalidate(15, $undoSteps = $$value)), undoSteps);

	let $writable,
		$$unsubscribe_writable = noop,
		$$subscribe_writable = () => ($$unsubscribe_writable(), $$unsubscribe_writable = subscribe(writable, $$value => $$invalidate(16, $writable = $$value)), writable);

	$$self.$$.on_destroy.push(() => $$unsubscribe_redoSteps());
	$$self.$$.on_destroy.push(() => $$unsubscribe_undoSteps());
	$$self.$$.on_destroy.push(() => $$unsubscribe_writable());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { icons = void 0 } = $$props;
	let type;

	function undo() {
		app?.undo();
	}

	function redo() {
		app?.redo();
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(11, app = $$props.app);
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(12, language = $$props.language);
		if ('icons' in $$props) $$invalidate(1, icons = $$props.icons);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 2048) {
			$: $$subscribe_writable($$invalidate(8, writable = app?.writable));
		}

		if ($$self.$$.dirty & /*$writable*/ 65536) {
			$: $$invalidate(13, disabled = !$writable);
		}

		if ($$self.$$.dirty & /*language*/ 4096) {
			$: $$invalidate(7, t = i18n[language]);
		}

		if ($$self.$$.dirty & /*disabled*/ 8192) {
			$: $$invalidate(2, type = disabled ? "disable" : "normal");
		}

		if ($$self.$$.dirty & /*app*/ 2048) {
			$: $$subscribe_undoSteps($$invalidate(6, undoSteps = app?.canUndoSteps));
		}

		if ($$self.$$.dirty & /*app*/ 2048) {
			$: $$subscribe_redoSteps($$invalidate(5, redoSteps = app?.canRedoSteps));
		}

		if ($$self.$$.dirty & /*disabled, $undoSteps*/ 40960) {
			$: $$invalidate(4, undo_disabled = disabled || !$undoSteps);
		}

		if ($$self.$$.dirty & /*disabled, $redoSteps*/ 24576) {
			$: $$invalidate(3, redo_disabled = disabled || !$redoSteps);
		}
	};

	return [
		theme,
		icons,
		type,
		redo_disabled,
		undo_disabled,
		redoSteps,
		undoSteps,
		t,
		writable,
		undo,
		redo,
		app,
		language,
		disabled,
		$redoSteps,
		$undoSteps,
		$writable
	];
}

class RedoUndo extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			app: 11,
			theme: 0,
			language: 12,
			icons: 1
		});
	}
}

export default RedoUndo;